import CategoryRequest from '@/shared/infrastructure/categories/Request'

const actions = {
  async fetchCategories({ commit }) {
    const categories = await CategoryRequest.fetchCategories()
    commit('setCategories', categories)
  },
  globalLoading({ commit }, isLoading) {
    commit('globalLoading', isLoading)
  },
  setQuickViewProduct({ commit }, payload) {
    commit('setQuickViewProduct', payload)
  }
}

export default actions
